import { render, staticRenderFns } from "./TheTableProducts.vue?vue&type=template&id=8ac8992a&scoped=true&"
import script from "./TheTableProducts.vue?vue&type=script&lang=ts&"
export * from "./TheTableProducts.vue?vue&type=script&lang=ts&"
import style0 from "./TheTableProducts.vue?vue&type=style&index=0&id=8ac8992a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac8992a",
  null
  
)

export default component.exports